import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import { types, fetchRelatedPagesSuccess } from '@blueberry/redux/header';
import { getRegion } from '@blueberry/redux/locale';
import { actions as errorActions } from '@blueberry/redux/error';

import { getRelatedPages } from '@blueberry/services/contents';
import { transformPages } from '@blueberry/redux/header';

import { HOME } from '@blueberry/constants/subjectType';

export function* fetchRelatedPagesFlow() {
  try {
    const region = yield select(getRegion);
    const name = `${HOME}_${region}`;

    const pages = yield call(getRelatedPages, name);

    yield put(fetchRelatedPagesSuccess(transformPages(pages)));
  } catch (err) {
    errorActions.sendError(err);
  }
}
export default function*() {
  yield all([takeLatest(types.FETCH_RELATED_PAGES, fetchRelatedPagesFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/header.js